import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\UpdateAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
const UpdateAssignedMaterialResourceController = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedMaterialResourceController.url(args, options),
    method: 'put',
})

UpdateAssignedMaterialResourceController.definition = {
    methods: ["put"],
    url: '/api/planning/{event}/material-resource/{material_resource}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
UpdateAssignedMaterialResourceController.url = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            event: args[0],
            material_resource: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return UpdateAssignedMaterialResourceController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
UpdateAssignedMaterialResourceController.put = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedMaterialResourceController.url(args, options),
    method: 'put',
})

export default UpdateAssignedMaterialResourceController